/*
 * FRMWRK collection filter scroll-lock fix — 09 Jul 2026 (verified on live preview)
 *
 * Bug: opening the mobile collection filter adds `open-drawer`/`open-sidebar`
 * to <html> (which sets overflow:hidden to freeze background scroll). Selecting
 * a filter value AJAX-re-renders #productgridcontainer, which recreates
 * #CollectionSidebar WITHOUT its `.open` class — so the drawer visually closes
 * but the lock classes stay stuck on <html>, leaving the page unscrollable with
 * no visible drawer.
 *
 * Fix: whenever the filter drawer is not actually open, ensure the lock classes
 * are cleared. No-ops on pages without #CollectionSidebar.
 */
(function () {
  var html = document.documentElement;

  function sync() {
    var sb = document.getElementById('CollectionSidebar');
    var open = !!(sb && sb.classList.contains('open'));
    if (!open && (html.classList.contains('open-drawer') || html.classList.contains('open-sidebar'))) {
      html.classList.remove('open-drawer', 'open-sidebar');
      html.style.removeProperty('padding-right');
    }
  }

  function start() {
    if (!document.getElementById('CollectionSidebar')) return;
    var grid = document.getElementById('productgridcontainer');
    if (grid) {
      new MutationObserver(function () { setTimeout(sync, 0); })
        .observe(grid, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('filter-item, facet-clear-all, .sec__collection-main')) {
        setTimeout(sync, 300);
        setTimeout(sync, 800);
      }
    }, true);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
